/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HomeHealthCertificationPractitioner
 */
export interface HomeHealthCertificationPractitioner {
    /**
     * 
     * @type {string}
     * @memberof HomeHealthCertificationPractitioner
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof HomeHealthCertificationPractitioner
     */
    credentials: string;
    /**
     * 
     * @type {string}
     * @memberof HomeHealthCertificationPractitioner
     */
    npi: string;
}

/**
 * Check if a given object implements the HomeHealthCertificationPractitioner interface.
 */
export function instanceOfHomeHealthCertificationPractitioner(value: object): value is HomeHealthCertificationPractitioner {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('credentials' in value) || value['credentials'] === undefined) return false;
    if (!('npi' in value) || value['npi'] === undefined) return false;
    return true;
}

export function HomeHealthCertificationPractitionerFromJSON(json: any): HomeHealthCertificationPractitioner {
    return HomeHealthCertificationPractitionerFromJSONTyped(json, false);
}

export function HomeHealthCertificationPractitionerFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeHealthCertificationPractitioner {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'credentials': json['credentials'],
        'npi': json['npi'],
    };
}

export function HomeHealthCertificationPractitionerToJSON(json: any): HomeHealthCertificationPractitioner {
    return HomeHealthCertificationPractitionerToJSONTyped(json, false);
}

export function HomeHealthCertificationPractitionerToJSONTyped(value?: HomeHealthCertificationPractitioner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'credentials': value['credentials'],
        'npi': value['npi'],
    };
}

